export const defaultEpiPropsModel = Object.freeze({
    formTitle: '',
    nameInputLabel: '',
    namePlaceholder: '',
    emailInputLabel: '',
    emailPlaceholder: '',
    nameRequiredError: '',
    emailRequiredError: '',
    emailInvalidError: '',
    submitCtaText: '',
});

